import { IState } from 'shared/store';
import { IPromotions } from 'shared/types/villagePromotions';

export const villagePromotionsSelector = (state: IState): IPromotions[] | null => {
  return state.promotionsVillageData?.promotions || null;
};
